"use client";

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface JobFiltersProps {
  onFilterChange: (filters: FilterState) => void;
}

export interface FilterState {
  specialty: string;
  location: string;
  roleType: string;
}

export default function JobFilters({ onFilterChange }: JobFiltersProps) {
  const [filters, setFilters] = useState<FilterState>({
    specialty: '',
    location: '',
    roleType: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const newFilters = {
      ...filters,
      [e.target.name]: e.target.value,
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleClear = () => {
    const clearedFilters = {
      specialty: '',
      location: '',
      roleType: '',
    };
    setFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-border shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Filter Jobs</h3>
        <button
          onClick={handleClear}
          className="text-sm text-primary hover:underline flex items-center"
        >
          <Icon name="XMarkIcon" size={16} className="mr-1" />
          Clear filters
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="roleType" className="block text-sm font-medium text-foreground mb-2">
            Role Type
          </label>
          <select
            id="roleType"
            name="roleType"
            value={filters.roleType}
            onChange={handleChange}
            className="w-full px-4 py-2 bg-white border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
          >
            <option value="">All roles</option>
            <option value="nursing">Nursing</option>
            <option value="allied">Allied Health</option>
            <option value="advanced">Advanced Practice</option>
            <option value="provider">Provider/Physician</option>
          </select>
        </div>

        <div>
          <label htmlFor="specialty" className="block text-sm font-medium text-foreground mb-2">
            Specialty
          </label>
          <input
            type="text"
            id="specialty"
            name="specialty"
            value={filters.specialty}
            onChange={handleChange}
            placeholder="ICU, ER, Med Surg..."
            className="w-full px-4 py-2 bg-white border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
          />
        </div>

        <div>
          <label htmlFor="location" className="block text-sm font-medium text-foreground mb-2">
            Location
          </label>
          <input
            type="text"
            id="location"
            name="location"
            value={filters.location}
            onChange={handleChange}
            placeholder="City, State"
            className="w-full px-4 py-2 bg-white border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
          />
        </div>
      </div>
    </div>
  );
}